import type { Module } from 'vuex'
import { UserService } from '@/services/User.service'
import IApiBaseService from '@/services/interfaces/IApiBase.service'
import {
  createBaseActions,
  createBaseMutations,
  createBaseState,
} from '@/store/modules/Base.module'
import { User, UserPagedResult } from '@/classes/generated-models'
import { IBaseModuleState } from '@/store/interfaces/IBase.module'
import type { IState } from '@/store'

export interface IUsersState extends IBaseModuleState<User, UserPagedResult> {}

const userService: IApiBaseService<User, UserPagedResult> = new UserService()

export const Users: Module<IUsersState, IState> = {
  namespaced: true,
  state: (): IUsersState => ({
    ...createBaseState<User, UserPagedResult>(userService),
  }),
  mutations: {
    ...createBaseMutations<User, UserPagedResult>(),
  },
  actions: {
    ...createBaseActions<User, UserPagedResult>(),
  },
}
